/** @jsx h */

import { Stage, Flex, Layer, Text, h, Rect } from "../comps";
import type { HeaderProps } from "./types";
import { directifyPadding } from "./utils";

export function minimal(props: HeaderProps) {
  const { sub, title, spacing, height, rtl } = props;

  return (
    <Stage width={700} height={height || 280} borderRadius={4}>
      <Layer>
        <Rect width={700} height={20} fill={title.stripe || "#dddddd"} opacity={1} />
      </Layer>
      <Flex padding={directifyPadding([118, 54, 28, 24], rtl)} justify="end" align={rtl ? "end" : "start"} spacing={10 + (spacing || 0)}>
        <Text
          rtl={rtl}
          font={title.font}
          color={title.color}
          maxLines={2}
          limits={title.limits}
          align={rtl ? "right" : "left"}
          fieldKey="title"
          letterSpacing={title.letterSpacing}
          lineHeight={title.lineHeight}
        >
          {title.text}
        </Text>
        {sub.text && (
          <Text
            rtl={rtl}
            color={sub.color}
            font={sub.font}
            maxLines={2}
            limits={sub.limits}
            align={rtl ? "right" : "left"}
            fieldKey="subtitle"
            letterSpacing={sub.letterSpacing}
            lineHeight={sub.lineHeight}
          >
            {sub.text}
          </Text>
        )}
      </Flex>
    </Stage>
  ).toSVG();
}
